import {
   Card,
   Flex,
   Text,
   Button,
   Box,
   Input,
   Select,
   useColorModeValue,
   useBreakpointValue,
   useOutsideClick,
   useToast,
   IconButton,
   ModalFooter,
   Switch,
   FormLabel,
   SimpleGrid,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
   Modal,
   useDisclosure,
   Spinner,
   Center,
   useColorMode,
} from '@chakra-ui/react';
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { FiRefreshCcw } from 'react-icons/fi';
import SalesSingleDataView from '../../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';

// UI
import Menu from 'components/menu/MainMenu';
import DynamicDataTable from '../../../masters/components/DynamicDataTable';

import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import { SearchIcon } from '@chakra-ui/icons';

import { useFilterData, downloadPDF, downloadExcel } from '../../../../../utils/DataTableUtils';
import { deleteRecord } from '../../../../../utils/util';

// ACTION
import {
   getIssueInventories,
   getIssueInventory,
   deleteIssueInventory,
   getSingleIssueInventories,
   emptyIssueInventory,
   deleteMultiIssue,
} from '../../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../../redux/actions/account';
import { useDispatch } from 'react-redux';
import { useUser, useGlobal } from 'contexts';
import { BsEye } from 'react-icons/bs';
import { postColumnsHideShow } from '../../../../../redux/actions/utility';
import { IoFilterOutline } from 'react-icons/io5';
import SalesInvoiceFilterModal from 'views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoiceFilterModal';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { AiTwotoneBook } from 'react-icons/ai';
import { X } from 'lucide-react';
import Loader from 'views/admin/default/Loader';

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const IssueReturnMaster = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const { user } = useUser();
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [dataId, setDataId] = useState(null);
   const daybookData = useSelector((state) => state.daybook?.list || []);
   const salesInvoiceData = useSelector((state) => state.issueInventory.list);
   const Totals = useSelector((state) => state?.issueInventory?.pagination?.totals);
   const totalCount = useSelector((state) => state.issueInventory.totalCount);
   const [singleEntity, setSingleEntity] = useState(null);
   const viewData = singleEntity;
   const pagination = useSelector((state) => state.issueInventory?.pagination);
   // const singleEntity = useSelector((state) => state?.issueInventory?.single || {});
   const account = useSelector((state) => state.account.single);
   const [currentPage, setCurrentPage] = useState('');
   const [limit, setLimit] = useState(10);
   const [isLoading, setIsLoading] = useState(false);
   const [data, setData] = useState([...salesInvoiceData]);
   const [searchQuery, setSearchQuery] = useState('');
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const [expanded, setExpanded] = useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = useState(false);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isDropdownOpen, setDropdownOpen] = useState(false);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [paginateData, setPaginateData] = useState({});
   const [isInitialLoad, setIsInitialLoad] = useState(true);
   const [isSearching, setIsSearching] = useState(false);
   const [isFiltering, setIsFiltering] = useState(false);
   const [isModalLoading, setIsModalLoading] = useState(false);
   const [isPageChanging, setIsPageChanging] = useState(false);
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const [filters, setFilters] = useState({
      pendingstatus: 'all',
      invoiceBook: 'all',
      duration: 'any',
      contact: '',
      item: '',
      docno: '',
      daybookId: '',
      accountId: '',
      fromDate: '',
      toDate: '',
      sortBy: 'id',
      sortOrder: 'DESC',
   });

   const DEFAULT_ISSUE_COLUMNS = {
      docno: true,
      transactionAt: true,
      daybookname: true,
      itemname: true,
      serialno: true,
      accountname: true,
      qty1: false,
      qty2: false,
      qty3: false,
      dueAt: false,
      dueDayCount: false,
      dueDays: false,
      txnDayCount: false,
      taxableAmount: true,
      gstAmount: true,
      netAmount: true,
      pendingAmount: true,
      createdu: true,
      updatedu: true,
      status: false,
      action: true,
      returnStatus: false,
      stockStatus: true,
   };

   const [columnVisibility, setColumnVisibility] = useState(() => {
      console.log('user issue settings', user?.viewJson[0]?.issue);

      const mergeWithDefaults = (existingVisibility) => {
         return {
            ...DEFAULT_ISSUE_COLUMNS,
            ...existingVisibility,
         };
      };

      const savedVisibility = localStorage.getItem('issueColumnVisibility');
      if (savedVisibility) {
         return mergeWithDefaults(JSON.parse(savedVisibility));
      }

      if (user?.viewJson?.length && user.viewJson[0]?.issue) {
         const userSettings = mergeWithDefaults(user.viewJson[0].issue);
         localStorage.setItem('issueColumnVisibility', JSON.stringify(userSettings));
         return userSettings;
      }

      return DEFAULT_ISSUE_COLUMNS;
   });

   const { viewDetail, paginate } = useMemo(() => {
      const data = viewData;
      const pagination = viewData?.pagination;
      return { viewDetail: data, paginate: pagination };
   }, [viewData]);

   const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);
   const [sorting, setSorting] = useState([]);

   const Admin = user?.isAdmin;
   const inventoryissueRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.inventoryissue
      : null;

   const flattenedData = useMemo(() => {
      if (!data || !Array.isArray(data)) return [];

      const flatData = [];

      data.forEach((invoice) => {
         // Calculate totals for quantities only (if needed)
         let totalQty1 = 0;
         let totalQty2 = 0;
         let totalQty3 = 0;

         const allSerialNos = [];
         const allItemNames = [];

         if (invoice.lineitems && Array.isArray(invoice.lineitems) && invoice.lineitems.length > 0) {
            invoice.lineitems.forEach((lineItem) => {
               totalQty1 += Number(lineItem.qty1) || 0;
               totalQty2 += Number(lineItem.qty2) || 0;
               totalQty3 += Number(lineItem.qty3) || 0;

               // Collect serial numbers
               if (lineItem.salesLineDetail) {
                  lineItem.salesLineDetail.forEach((detail) => {
                     if (detail.serialNo) {
                        allSerialNos.push(detail.serialNo);
                     }
                  });
               }

               // Collect item names
               if (lineItem.itemName) {
                  allItemNames.push(lineItem.itemName);
               }
            });
         }

         flatData.push({
            ...invoice,
            qty1: totalQty1,
            qty2: totalQty2,
            qty3: totalQty3,
            taxableAmount: invoice.taxableAmount,
            gstAmount: invoice.gstAmount,
            netAmount: invoice.netAmount,
            pendingamt: invoice.pendingamt,

            itemname: allItemNames.length > 0 ? allItemNames.join(', ') : 'No Items',
            serialno: allSerialNos.length > 0 ? allSerialNos.join(', ') : '',

            _aggregatedTotals: {
               qty1: totalQty1,
               qty2: totalQty2,
               qty3: totalQty3,
               itemCount: invoice.lineitems?.length || 0,
            },
         });
      });
      return flatData;
   }, [data]);

   // Update the quantityTotals calculation to use the aggregated data
   const quantityTotals = useMemo(() => {
      let totalQty1 = 0;
      let totalQty2 = 0;
      let totalQty3 = 0;

      if (flattenedData && flattenedData.length) {
         flattenedData.forEach((invoice, invIdx) => {
            totalQty1 += Number(invoice.qty1) || 0;
            totalQty2 += Number(invoice.qty2) || 0;
            totalQty3 += Number(invoice.qty3) || 0;
         });
      }

      return { totalQty1, totalQty2, totalQty3 };
   }, [flattenedData]);

   const columnsData = useMemo(
      () => [
         { id: 'docno', header: 'DOC NO', accessor: 'docno' },
         {
            id: 'transactionAt',
            header: 'Bill Date',
            accessor: 'transactionAt',
         },
         { id: 'txnDayCount', header: 'Bill Days Count', accessor: 'txnDayCount' },
         { id: 'daybookname', header: 'Daybook', accessor: 'daybookname' },
         {
            id: 'itemname',
            header: 'Item',
            accessor: 'itemname',
         },
         {
            id: 'serialno',
            header: 'serial No',
            accessor: 'serialno',
         },
         { id: 'accountname', header: 'Party', accessor: 'accountname' },
         {
            id: 'qty1',
            header: `Qty 1 (${quantityTotals.totalQty1})`,
            accessor: 'qty1',
            Cell: ({ value }) => {
               return value;
            },
         },
         {
            id: 'qty2',
            header: `Qty 2 (${quantityTotals.totalQty2})`,
            accessor: 'qty2',
            Cell: ({ value }) => {
               return value;
            },
         },
         {
            id: 'qty3',
            header: `Qty 3 (${quantityTotals.totalQty3})`,
            accessor: 'qty3',
            Cell: ({ value }) => {
               return value;
            },
         },
         {
            id: 'taxableAmount',
            header: 'Taxable Amount',
            accessor: 'taxableAmount',
         },
         {
            id: 'gstAmount',
            header: 'GST',
            accessor: 'gstAmount',
         },
         { id: 'netAmount', header: 'Net Amount', accessor: 'netAmount' },
         {
            id: 'pendingAmount',
            header: 'Pending Amount',
            accessor: 'pendingAmount',
         },
         { id: 'dueAt', header: 'Due At', accessor: 'dueAt' },
         { id: 'dueDays', header: 'Due Days', accessor: 'dueDays' },
         { id: 'dueDayCount', header: 'Over Due Days', accessor: 'dueDayCount' },
         {
            id: 'stockStatus',
            header: 'Stock Status',
            accessor: 'stockStatus',
         },
         { id: 'returnStatus', header: 'RETURN STATUS', accessor: 'returnStatus' },
         { id: 'createdu', header: 'Created By', accessor: 'createdu' },
         { id: 'updatedu', header: 'Updated By', accessor: 'updatedu' },
         { id: 'status', header: 'STATUS', accessor: 'status' },
      ],
      [quantityTotals, Totals],
   );

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      ?.map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const wrapperRef = useRef();

   const filteredData = useFilterData(data, searchQuery, columns);

   const handlePageChange = (directionOrPage) => {
      if (typeof directionOrPage === 'number') {
         setIsPageChanging(true);
         setCurrentPage(directionOrPage);
      } else {
         const newPage = directionOrPage === 'next' ? pagination.nextPage : pagination.previousPage;
         if (newPage) setCurrentPage(newPage);
      }
   };

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue('');
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);
      setLimit(newLimit);
      setCurrentPage(1);
   };

   const handleMultiDelete = async (data) => {
      const res = await dispatch(deleteMultiIssue({ ids: data }));
      if (res?.code === 1) {
         getSalesInvoices();
      }
   };

   const handleViewSingleData = async (data) => {
      setIsModalLoading(true); // Use separate state
      onOpen(); // Open modal immediately

      try {
         setSingleEntity(data);
         // await dispatch(getIssueInventory(id));
         const currentIdx = salesInvoiceData.findIndex((x) => x.id === data.id);

         const prevObject = currentIdx > 0 ? salesInvoiceData[currentIdx - 1] : null;
         const nextObject = currentIdx < salesInvoiceData.length - 1 ? salesInvoiceData[currentIdx + 1] : null;

         // await dispatch(
         //    getSingleIssueInventories({
         //       id: id,
         //       page: 1,
         //       limit: 1,
         //       sortBy: 'id',
         //       sortOrder: 'desc',
         //    }),
         // );
         setPaginateData({
            hasPreviousPage: prevObject ? true : false,
            previousPage: prevObject ? currentIdx - 1 : null,
            nextPage: nextObject ? currentIdx + 1 : null,
            hasNextPage: nextObject ? true : false,
         });
         onOpen();
         setIsOpenSingleView(true);
      } catch (error) {
         console.error('Error fetching sales data:', error);
      } finally {
         setIsModalLoading(false); // Update separate state
      }
   };

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const handleOnClose = useCallback(() => {
      setIsOpenSingleView(false);
      dispatch(emptyIssueInventory());
      setIsModalLoading(false);
      onClose();
   }, [dispatch, onClose]);

   const getSalesInvoices = useCallback(async () => {
      if (user && user?.loginhistory?.companyId && currentPage !== '') {
         setIsLoading(true);
         setIsInitialLoad(true);

         const sortBy = filters.sortBy || (sorting.length > 0 ? sorting[0]?.id : 'id');
         const sortOrder = filters.sortOrder || (sorting?.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC');
         const {
            paymentStatus,
            invoiceBook,
            duration,
            contact,
            item,
            docno,
            daybookIds,
            accountIds,
            accountId,
            fromDate,
            toDate,
         } = filters;

         try {
            await dispatch(emptyIssueInventory());
            await dispatch(
               getIssueInventories({
                  page: currentPage,
                  limit: limit,
                  search: searchQuery,
                  companyId: user?.loginhistory?.companyId,
                  sortBy,
                  sortOrder,
                  paymentStatus: paymentStatus !== 'all' ? paymentStatus : undefined,
                  invoiceBook: invoiceBook !== 'all' ? invoiceBook : undefined,
                  duration: duration !== 'any' ? duration : undefined,
                  contact: contact || undefined,
                  item: item || undefined,
                  docno: docno || undefined,
                  daybookIds: daybookIds && daybookIds.length > 0 ? daybookIds.join(',') : undefined || undefined,
                  accountIds: accountIds && accountIds.length > 0 ? accountIds.join(',') : undefined || undefined,
                  accountId: accountId || undefined,
                  fromDate: fromDate || undefined,
                  toDate: toDate || undefined,
                  isReturn: true,
               }),
            );
         } catch (error) {
            console.error('Error fetching issue return inventories:', error);
         } finally {
            setIsLoading(false);
            setIsInitialLoad(false);
            setIsSearching(false);
            setIsFiltering(false);
            setIsPageChanging(false);
         }
      }
   }, [currentPage, dispatch, limit, searchQuery, sorting, user, filters]);

   // Debounced search effect
   useEffect(() => {
      const timeoutId = setTimeout(() => {
         if (searchQuery !== '') {
            setIsSearching(true);
            setCurrentPage(1);
         }
      }, 500);

      return () => clearTimeout(timeoutId);
   }, [searchQuery]);

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      getSalesInvoices();
   }, [getSalesInvoices]);

   useEffect(() => {
      setData([...salesInvoiceData]);
   }, [salesInvoiceData]);

   useEffect(() => {
      if (currentPage === '') {
         const page = localStorage.getItem('issuepage');
         setCurrentPage(page ? Number(page) : 1);
         localStorage.removeItem('issuepage');
      }
   }, [currentPage]);

   useEffect(() => {
      if (user && !user?.packageData?.[0]?.issue) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      setPaginateData(paginate);
   }, [paginate]);

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
            { label: 'Notes', value: singleEntity?.notes || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   useEffect(() => {
      if (isOpenSingleView) {
         dispatch(getAccountById({ id: singleEntity?.accountId, compId: user?.loginhistory?.companyId }));
      }
   }, [dispatch, isOpenSingleView, singleEntity?.accountId, user?.loginhistory?.companyId]);

   useEffect(() => {
      const handleKeyDown = (event) => {
         if ((event.key === '+' || (event.key === '=' && event.shiftKey)) && user && !user.isExpired) {
            event.preventDefault();
            navigate('/admin/inventory/issue/add');
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [navigate]);

   useEffect(() => {
      localStorage.setItem('issueColumnVisibility', JSON.stringify(columnVisibility));
   }, [columnVisibility]);

   useEffect(() => {
      if (user?.viewJson?.length && user.viewJson[0]?.issue) {
         const mergedVisibility = {
            ...DEFAULT_ISSUE_COLUMNS,
            ...user.viewJson[0].issue,
         };
         setColumnVisibility(mergedVisibility);
         localStorage.setItem('issueColumnVisibility', JSON.stringify(mergedVisibility));
      }
   }, [user]);

   const ColumnVisibilityModal = ({ isOpen, onClose, columnVisibility, setColumnVisibility, user }) => {
      const [localVisibility, setLocalVisibility] = useState(columnVisibility);
      const companyId = Number(localStorage.getItem('companyId'));
      const dispatch = useDispatch();

      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      useEffect(() => {
         if (isOpen) {
            setLocalVisibility(columnVisibility);
         }
      }, [isOpen, columnVisibility]);

      const handleToggle = (key) => {
         setLocalVisibility((prev) => ({ ...prev, [key]: !prev[key] }));
      };

      const handleSave = async () => {
         try {
            const updatedViewJson = user.viewJson
               ? user.viewJson.map((item) =>
                    item.companyId === companyId ? { ...item, sales: localVisibility } : item,
                 )
               : [{ companyId, sales: localVisibility }];

            await dispatch(
               postColumnsHideShow({
                  userId: user?.id,
                  viewJson: updatedViewJson,
               }),
            );

            setColumnVisibility(localVisibility);
            localStorage.setItem('issueColumnVisibility', JSON.stringify(localVisibility));
            onClose();
         } catch (error) {
            console.log(error);
         }
      };

      return (
         <Modal isOpen={isOpen} onClose={onClose} size="4xl">
            <ModalOverlay />
            <ModalContent
               bg={
                  isDark
                     ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 50%, #1e293b 100%)'
                     : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #ffffff 100%)'
               }
               border={isDark ? '1px solid #334155' : '1px solid #e2e8f0'}>
               <ModalHeader
                  borderBottom={isDark ? '1px solid #334155' : '1px solid #e2e8f0'}
                  bg={isDark ? 'rgba(30, 41, 59, 0.5)' : 'rgba(248, 250, 252, 0.5)'}>
                  <Flex justify="space-between" align="center">
                     <Box>
                        <Text color={isDark ? 'white' : 'gray.900'} fontSize="2xl" fontWeight="bold">
                           Show/Hide Columns
                        </Text>
                        <Text color={isDark ? 'gray.400' : 'gray.600'} fontSize="sm" mt={1}>
                           Customize which columns appear in your sales invoice table
                        </Text>
                     </Box>
                  </Flex>
               </ModalHeader>

               <ModalCloseButton />

               <ModalBody maxH="60vh" overflowY="auto" py={6}>
                  <SimpleGrid columns={2} spacing={4}>
                     {Object.entries(localVisibility).map(([key, value]) => (
                        <Card
                           key={key}
                           p={5}
                           cursor="pointer"
                           border="2px solid"
                           borderColor={value ? (isDark ? 'blue.500' : 'blue.400') : isDark ? 'gray.600' : 'gray.300'}
                           bg={value ? (isDark ? 'blue.900/20' : 'blue.50/50') : isDark ? 'gray.800/30' : 'white/50'}
                           _hover={{ transform: 'scale(1.02)' }}
                           transition="all 0.3s"
                           onClick={() => handleToggle(key)}>
                           <Flex justify="space-between" align="center">
                              <FormLabel
                                 htmlFor={key}
                                 mb={0}
                                 fontWeight="semibold"
                                 color={isDark ? 'white' : 'gray.900'}
                                 cursor="pointer">
                                 {key.split(/(?=[A-Z])/).join(' ')}
                              </FormLabel>
                              <Switch
                                 id={key}
                                 isChecked={value}
                                 onChange={(e) => {
                                    e.stopPropagation();
                                    handleToggle(key);
                                 }}
                                 colorScheme="blue"
                                 size="lg"
                              />
                           </Flex>
                           <Flex align="center" gap={2} mt={3}>
                              <Box
                                 w={2}
                                 h={2}
                                 borderRadius="full"
                                 bg={value ? (isDark ? 'blue.400' : 'blue.500') : isDark ? 'gray.600' : 'gray.400'}
                              />
                              <Text
                                 fontSize="xs"
                                 fontWeight="medium"
                                 color={value ? (isDark ? 'blue.400' : 'blue.600') : isDark ? 'gray.500' : 'gray.500'}>
                                 {value ? 'Visible' : 'Hidden'}
                              </Text>
                           </Flex>
                        </Card>
                     ))}
                  </SimpleGrid>
               </ModalBody>

               <ModalFooter
                  borderTop={isDark ? '1px solid #334155' : '1px solid #e2e8f0'}
                  bg={isDark ? 'rgba(30, 41, 59, 0.5)' : 'rgba(248, 250, 252, 0.5)'}>
                  <Button
                     variant="ghost"
                     mr={3}
                     rounded={'md'}
                     onClick={onClose}
                     color={isDark ? 'gray.300' : 'gray.700'}
                     _hover={{ bg: isDark ? 'gray.700' : 'gray.200' }}>
                     Cancel
                  </Button>
                  <Button
                     className={`
              !px-6 !py-2.5 !rounded-lg !font-semibold !transition-all !duration-200 !shadow-lg
              ${
                 isDark
                    ? '!bg-gradient-to-r !from-blue-600 !to-indigo-600 hover:!from-blue-500 hover:!to-indigo-500'
                    : '!bg-gradient-to-r !from-blue-500 !to-indigo-500 hover:!from-blue-600 hover:!to-indigo-600'
              }
              !text-white
              ${isDark ? '!shadow-blue-500/30' : '!shadow-blue-400/30'}
              hover:!shadow-xl
              hover:!-translate-y-1
              active:!translate-y-0
            `}
                     onClick={handleSave}>
                     Save
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>
      );
   };
   const { userGlobalSettingsData } = useGlobal();

   const deleteSales = () => {
      const selectedData = data.filter((da) => da.id === viewDetail?.id);
      const selectedDaybook = daybookData.filter((dd) => dd.id === selectedData[0].daybookId);
      console.log('selectedData', selectedData, selectedData[0].daybookId, daybookData, selectedDaybook);
      if (selectedDaybook.length > 0 && selectedDaybook[0]?.askPasswordOnDelete) {
         setDataId(viewDetail?.id);
         setIsModalOpen(true);
      } else {
         deleteRecord(
            viewDetail?.id,
            deleteIssueInventory,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
      }
      // deleteRecord(viewDetail?.id, deleteIssueInventory, dispatch);
      // onClose();
   };

   const handlePrevPage = useCallback(
      async (page) => {
         setIsModalLoading(true);
         try {
            await dispatch(
               getSingleIssueInventories({
                  page: page,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
         } finally {
            setIsModalLoading(false);
         }
      },
      [dispatch],
   );

   const handleNextPage = useCallback(
      async (page) => {
         setIsModalLoading(true);
         try {
            await dispatch(
               getSingleIssueInventories({
                  page: page,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
         } finally {
            setIsModalLoading(false);
         }
      },
      [dispatch],
   );

   const handleApplyFilters = (newFilters) => {
      console.log('Applying filters:', newFilters);

      setFilters((prev) => ({
         ...prev,
         ...newFilters,
         sortBy: newFilters.sortBy || 'id',
         sortOrder: newFilters.sortOrder || 'DESC',
      }));

      setSorting([]);

      setCurrentPage(1);
   };

   // Combined loading state
   const hoverBg = useColorModeValue('gray.200', 'gray.600');
   const [isRotating, setIsRotating] = useState(false);
   const shouldShowLoader = isLoading || isInitialLoad || isSearching || isFiltering || isPageChanging;
   const handleRefreshData = async () => {
      setIsRotating(!isRotating);
      getSalesInvoices();
   };

   return (
      <>
         <Card
            flexDirection="column"
            w="100%"
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}
            position="relative"
            py="10px"
            bg={backgroundColor}>
            <Flex
               width={{ base: '100%', md: 'auto' }}
               mb="8px"
               px={{ base: '1px', md: '25px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '17px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Issue Return
                  </Text>
               </Flex>

               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && user && !user.isExpired && (
                     <button
                        onClick={() => navigate('/admin/inventory/issue/add')}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                           isDark
                              ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                              : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                        }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                              isDark ? 'via-cyan-100/20' : 'via-white/30'
                           }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                              isDark
                                 ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                 : 'bg-white/20 group-hover:bg-white/30'
                           }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}
                  <Box>
                     <IconButton
                        icon={
                           <Box
                              as={FiRefreshCcw}
                              transform={isRotating ? 'rotate(-360deg)' : 'rotate(0deg)'}
                              transition="transform 1s ease"
                           />
                        }
                        aria-label="Refresh"
                        variant="ghost"
                        size="lg"
                        _hover={{ bg: hoverBg }}
                        isRound
                        onClick={handleRefreshData}
                     />
                  </Box>
                  {/* Filter Button */}
                  <Box cursor={'pointer'} onClick={onFilterOpen}>
                     <IoFilterOutline size={22} />
                  </Box>
                  <Box cursor={'pointer'} onClick={() => navigate('/admin/inventory/issue/managedaybook')}>
                     <AiTwotoneBook size={22} />
                  </Box>
                  <Flex align="center" flexShrink={0}>
                     {/* Previous Page Button */}
                     <Box
                        onClick={() => pagination?.hasPreviousPage && handlePageChange('prev')}
                        cursor={pagination?.hasPreviousPage ? 'pointer' : 'not-allowed'}
                        opacity={pagination?.hasPreviousPage ? 1 : 0.5}
                        role="button"
                        aria-label="Previous page">
                        <MdNavigateBefore size={28} />
                     </Box>

                     {/* Current Page Display with Manual Input */}
                     <Flex align="center" mx="10px" position="relative">
                        {!isEditingPage ? (
                           <Flex align="center">
                              <Text
                                 as="span"
                                 fontSize={{ base: '14px', lg: '17px' }}
                                 minWidth="40px"
                                 textAlign="center"
                                 onClick={handlePageClick}
                                 cursor="pointer"
                                 border="2px solid"
                                 borderColor="blue.500"
                                 color="blue.600"
                                 fontWeight="medium"
                                 px={2}
                                 py={1}
                                 borderRadius="md"
                                 _hover={{ bg: 'blue.50' }}>
                                 {pagination?.currentPage || 1}
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }} mx={1}>
                                 /
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }}>
                                 {pagination?.totalPages || 1}
                              </Text>
                           </Flex>
                        ) : (
                           <Flex align="center">
                              <Input
                                 type="number"
                                 min={1}
                                 max={pagination?.totalPages}
                                 value={pageInputValue}
                                 onChange={(e) => setPageInputValue(e.target.value)}
                                 onBlur={handlePageInputBlur}
                                 onKeyDown={handlePageKeyDown}
                                 fontSize={{ base: '14px', lg: '17px' }}
                                 width="40px"
                                 textAlign="center"
                                 p={0}
                                 border="2px solid"
                                 borderColor="blue.500"
                                 _focus={{ outline: 'none', ring: '1px', ringColor: 'blue.500' }}
                                 autoFocus
                              />
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }} mx={1}>
                                 /
                              </Text>
                              <Text as="span" fontSize={{ base: '14px', lg: '17px' }}>
                                 {pagination?.totalPages || 1}
                              </Text>
                           </Flex>
                        )}
                     </Flex>

                     {/* Next Page Button */}
                     <Box
                        onClick={() => pagination?.hasNextPage && handlePageChange('next')}
                        cursor={pagination?.hasNextPage ? 'pointer' : 'not-allowed'}
                        opacity={pagination?.hasNextPage ? 1 : 0.5}
                        role="button"
                        aria-label="Next page">
                        <MdNavigateNext size={28} />
                     </Box>
                  </Flex>

                  {/* Page Size Select */}
                  <Select
                     width="auto"
                     h={{ base: 9, lg: 10 }}
                     marginRight="5"
                     value={limit === pagination?.totalProducts ? 'ALL' : limit.toString()}
                     onChange={handlePageSizeChange}>
                     <option value="10">10</option>
                     <option value="20">20</option>
                     <option value="30">30</option>
                     <option value="ALL">All</option>
                  </Select>

                  {/* Column Visibility Button */}
                  <IconButton
                     colorScheme="gray"
                     icon={<BsEye />}
                     size="md"
                     mr={1}
                     onClick={() => setIsColumnModalOpen(true)}
                  />

                  {/* Search Field */}
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           value={searchQuery}
                           color={icon}
                           onChange={(e) => setSearchQuery(e.target.value)}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
               </Flex>

               {isMobileOrTablet && user && !user.isExpired && (
                  <Box position="fixed" bottom="4" right="4" zIndex={999}>
                     <button
                        onClick={() => navigate('/admin/inventory/issue/add')}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                           isDark
                              ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                              : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                        }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                              isDark ? 'via-cyan-100/20' : 'via-white/30'
                           }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                              isDark
                                 ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                 : 'bg-white/20 group-hover:bg-white/30'
                           }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  </Box>
               )}
            </Flex>

            {/* Loader Section */}
            {isInitialLoad ? (
               <Loader />
            ) : (
               <DynamicDataTable
                  singleEntityRights={inventoryissueRight}
                  table={table}
                  tableData={flattenedData}
                  columnsData={columns}
                  emptyMessage="No Inventory Issue Return data found"
                  handleViewSingleData={handleViewSingleData}
                  toggleDropdown={toggleDropdown}
                  onEditClick={(row) => {
                     localStorage.setItem('issuepage', currentPage);
                     navigate(`/admin/inventory/issue/edit/${row.id}`);
                  }}
                  onDeleteClick={(id) => {
                     const selectedData = data.filter((da) => da.id === id);
                     const selectedDaybook = daybookData.filter((dd) => dd.id === selectedData[0].daybookId);
                     console.log('selectedData', selectedData, selectedData[0].daybookId, daybookData, selectedDaybook);
                     if (selectedDaybook.length > 0 && selectedDaybook[0]?.askPasswordOnDelete) {
                        setDataId(id);
                        setIsModalOpen(true);
                     } else {
                        deleteRecord(
                           id,
                           deleteIssueInventory,
                           dispatch,
                           user?.loginhistory?.companyId,
                           userGlobalSettingsData,
                        );
                     }
                     // deleteRecord(id, deleteIssueInventory, dispatch);
                  }}
                  onMultiDeleteClick={(data) => handleMultiDelete(data)}
                  canDelete={true}
                  columnVisibility={columnVisibility}
                  type="issuereturn"
                  totalCount={pagination.total}
                  isLoading={isLoading}
               />
            )}
         </Card>

         {isOpen && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : (
                  <SalesDetails
                     singleEntityRights={inventoryissueRight}
                     isOpen={isOpen}
                     onClose={handleOnClose}
                     title="Issue Inventory"
                     handlePrevPage={handlePrevPage}
                     handleNextPage={handleNextPage}
                     paginate={paginateData}
                     totalCount={totalCount}
                     viewDetail={viewDetail}
                     entityType="issueinventory"
                     singleEntity={singleEntity}
                     onEditFormClose={() => setIsOpenSingleView(true)}
                     setIsOpenSingleView={setIsOpenSingleView}
                     isEditFormOpen={isEditFormOpen}
                     setIsEditFormOpen={setIsEditFormOpen}
                     lineItems={viewDetail?.lineitems}
                     billTerms={viewDetail?.issueLineDetail}
                     onDelete={deleteSales}
                     handleSerchClose={() => console.log('')}
                  />
               )}
            </div>
         )}

         <ColumnVisibilityModal
            isOpen={isColumnModalOpen}
            onClose={() => setIsColumnModalOpen(false)}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            user={user}
         />

         <SalesInvoiceFilterModal
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            onApplyFilters={handleApplyFilters}
            entityType="issuemaster"
            Totals={Totals}
         />

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={deleteRecord}
            id={dataId}
            deleteApi={deleteIssueInventory}
            dispatch={dispatch}
            type={'receive'}
            userGlobalSettingsData={userGlobalSettingsData}
         />
      </>
   );
};

export default IssueReturnMaster;
